import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Is Community Hearts only for serious relationships?",
    a: "Yes. Every member answers intent questions before matching, so everyone on the platform is here for the same reason.",
  },
  {
    q: "How does the 5-day window work?",
    a: "A match is held for five days. Speak, meet, decide. When the window closes, it closes — no one can collect you or keep you as an option.",
  },
  {
    q: "Is my identity verified?",
    a: "Yes. Every member completes selfie verification during onboarding so you always know you're talking to a real person.",
  },
  {
    q: "What makes Community Hearts different?",
    a: "No swiping culture, no endless browsing. Voice messages instead of text, verified identities, and matches that expire — because real connection requires real intention.",
  },
  {
    q: "Is there a free trial?",
    a: "Yes. Try the full experience free for 7 days, no commitment required.",
  },
  {
    q: "Why Richmond first?",
    a: "We open one city at a time, with care. Richmond is first. The cities with the deepest waitlists open next.",
  },
  {
    q: "What is Hearts+?",
    a: "Hearts+ is the membership for the full room — voice, unlimited matches, and the quiet privileges of the house. Your first week is on us.",
  },
  {
    q: "Do early members receive a founding rate?",
    a: "Yes. Early Richmond members receive a founding rate, and the first 1,000 in each city keep a Gold Status badge on their profile.",
  },
];

export const FAQ = () => {
  return (
    <section className="border-t border-[#C4A36A]/30 bg-[#F7F3EA]" data-testid="faq-section">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-6 md:px-12 md:py-40">
        <div className="grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-gold-deep" data-testid="faq-overline">
              Questions
            </p>
            <h2 className="font-serif text-4xl leading-tight tracking-tight text-[#7A5A14] md:text-5xl">
              Questions, <span className="italic text-gold">answered.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-[#C4A36A]/40" data-testid={`faq-item-${i + 1}`}>
                  <AccordionTrigger className="py-5 text-left font-serif text-lg tracking-tight text-[#1A120C] hover:text-[#A08448] hover:no-underline sm:py-7 sm:text-xl md:text-2xl" data-testid={`faq-question-${i + 1}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="max-w-2xl pb-5 font-serif text-base leading-relaxed text-[#3A2C20] sm:pb-7 md:text-lg" data-testid={`faq-answer-${i + 1}`}>
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
